import CryptoJS from 'crypto-js'

export class LocalStorageSecure implements Storage {
  constructor(secretKey: string) {
    this.secretKey = secretKey
    return new Proxy(this, {
      // overrides getting Statuses.name
      get(target, name: string) {
        if (name in target) {
          const result = target[name]
          return typeof result === 'function' ? result.bind(target) : result
        }
        return target.getItem(name)
      },
      // overrides getting Statuses.name
      set(target, name: string, value: string) {
        if (name in target) target[name] = value
        else target.setItem(name, value)
        return true
      },
    })
  }
  // eslint-disable-next-line no-restricted-globals
  [name: string]: any
  get length() {
    return localStorage.length
  }
  clear(): void {
    localStorage.clear()
  }
  key(index: number): string | null {
    return localStorage.key(index)
  }
  secretKey: string
  // Mã hóa dữ liệu trước khi lưu trữ vào LocalStorage
  setItem(key: string, value: string) {
    const encryptedValue = CryptoJS.AES.encrypt(value, this.secretKey)
    localStorage.setItem(key, encryptedValue.toString())
  }

  // Giải mã dữ liệu trước khi truy xuất từ LocalStorage
  getItem(key: string) {
    const encryptedValue = localStorage.getItem(key)
    if (encryptedValue) {
      try {
        const decryptedValue = CryptoJS.AES.decrypt(encryptedValue, this.secretKey).toString(CryptoJS.enc.Utf8)
        return decryptedValue
      } catch {
        return null
      }
    }
    return null
  }

  // Xóa dữ liệu khỏi LocalStorage
  removeItem(key: string) {
    localStorage.removeItem(key)
  }
}
